module.exports = __webpack_public_path__ + "static/media/burning_t34_.c79ebbc4.jpg";